<template>
<div :ref="chart.uuid"></div>
</template>

<script>
import Plotly from 'plotly.js-dist-min';

export default {
  name: 'ReactiveChart',
	props: ["chart"],
	mounted() {
		Plotly.newPlot(this.$refs[this.chart.uuid], this.chart.traces, this.chart.layout, {responsive: true});

		this.$refs[this.chart.uuid].on('plotly_relayout',
    (eventdata)=>{  
            this.$emit("relayout_zoom", eventdata);
          console.log('new zoom range from child component')
		  console.log(eventdata)
    });

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>





